import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { MUNILY_QTY_STEPPER_DEFAULTS } from './qty-stepper.types';

@Component({
  selector: 'common-qty-stepper',
  templateUrl: './qty-stepper.component.html',
  styleUrls: ['./qty-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QtyStepperComponent implements OnChanges {
  @Input() value = MUNILY_QTY_STEPPER_DEFAULTS.value;
  @Input() min = MUNILY_QTY_STEPPER_DEFAULTS.min;
  @Input() max = MUNILY_QTY_STEPPER_DEFAULTS.max;
  @Input() disabled = MUNILY_QTY_STEPPER_DEFAULTS.disabled;
  @Input() decreaseAriaLabel = '';
  @Input() increaseAriaLabel = '';
  @Output() valueChange = new EventEmitter<number>();

  public draft = '1';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.draft = String(this.value);
    }
  }

  private _clamp(n: number): number {
    return Math.max(this.min, Math.min(this.max, n));
  }

  onClick(event: MouseEvent, next: number): void {
    event.stopPropagation();
    this.valueChange.emit(this._clamp(next));
  }

  onInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
    this.draft = input;
    if (input !== '') {
      this.valueChange.emit(this._clamp(parseInt(input, 10)));
    }
  }

  onBlur(): void {
    if (this.draft === '' || Number.isNaN(parseInt(this.draft, 10))) {
      this.draft = String(this.value);
      return;
    }
    this.valueChange.emit(this._clamp(parseInt(this.draft, 10)));
  }
}
